import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.iubenda.com/iubenda.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <footer className="bg-transparent py-6">
      <div className="max-w-full mx-auto px-8 xl:px-24">
        <div className="hidden lg:flex justify-between">
          <div className="flex flex-col space-y-6">
            <a
              href="https://www.instagram.com/notordinarybarbers/"
              target="_blank"
              rel="noreferrer"
              className="hover:opacity-80"
            >
              <img src="/Instagram_icon.svg" alt="Instagram icon" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61555831996088"
              target="_blank"
              rel="noreferrer"
              className="hover:opacity-80"
            >
              <img src="/Facebook_icon.svg" alt="Facebook icon" />
            </a>
          </div>
          <div
            className={`absolute left-1/2 transform -translate-x-1/2 text-center space-y-6 ${
              isHomePage ? "visible" : "invisible"
            }`}
          >
            <div className="font-bold">
              <a
                target="_blank"
                rel="noreferrer"
                className="hover:underline"
                href="https://maps.app.goo.gl/M7hb332Gd977PTdS7"
              >
                CORSO VITTORIO EMANUELE II 218/A - TORINO 10138
              </a>
            </div>
            <div>{t("footer.metro")}</div>
          </div>
          <div className="flex flex-col space-y-6 text-right">
            <div className="font-bold">
              <a href="tel:+390110567285" className="hover:underline">
                011.056.7285
              </a>
            </div>
            <div>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://wa.me/message/LGAT32OFGN5VO1"
                className="hover:underline"
              >
                {t("footer.info")}
              </a>
            </div>
          </div>
        </div>
        <div className="lg:hidden flex justify-center space-x-4">
          <a
            href="https://www.instagram.com/notordinarybarbers/"
            target="_blank"
            rel="noreferrer"
            className="hover:opacity-80"
          >
            <img src="/Instagram_icon.svg" alt="Instagram icon" />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61555831996088"
            target="_blank"
            rel="noreferrer"
            className="hover:opacity-80"
          >
            <img src="/Facebook_icon.svg" alt="Facebook icon" />
          </a>
        </div>
      </div>
      <div className="mt-6 pt-4 text-xs text-center flex flex-col items-center lg:flex-row lg:justify-center lg:space-x-4 font-poppins tracking-wide">
        <div className="flex flex-row items-center lg:space-x-4">
          <p>P.IVA: 12945400013</p>
          <span className="block mx-2">|</span>
          <p>
            <a
              href="https://www.iubenda.com/privacy-policy/16157539"
              className="iubenda-black iubenda-noiframe iubenda-embed"
              title="Privacy Policy"
            >
              Privacy Policy
            </a>
          </p>
          <span className="hidden lg:block mx-2">|</span>
        </div>
        <p className="mt-2 lg:mt-0">
          &copy; {new Date().getFullYear()} NOB SNC. {t("footer.rights")}.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
